
import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Business } from "@/types";
import { formatCategoryDisplay } from "@/services/business/categoryService";

interface BusinessCardProps {
  business: Business;
}

const BusinessCard: React.FC<BusinessCardProps> = ({ business }) => {
  return (
    <Link to={`/business/${business.id}`}>
      <Card className="overflow-hidden h-full transition-transform hover:scale-105 cursor-pointer">
        <div className="relative h-48 overflow-hidden">
          <img
            src={business.imageUrl}
            alt={business.name}
            className="object-cover w-full h-full"
          />
        </div>
        <CardContent className="pt-4">
          <div className="flex items-center justify-between mb-2">
            <Badge className="bg-eco-100 text-eco-800 hover:bg-eco-200">
              {formatCategoryDisplay(business.category)}
            </Badge>
          </div>
          <h3 className="font-semibold text-lg mb-1 line-clamp-1">{business.name}</h3>
          <div className="flex items-center text-muted-foreground text-sm mb-2">
            <MapPin className="h-4 w-4 mr-1" />
            <span>{business.city}, {business.state}</span>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2">{business.description}</p>
        </CardContent>
        <CardFooter className="pt-0 pb-4">
          <div className="flex flex-wrap gap-1">
            {business.tags && business.tags.slice(0, 3).map((tag) => (
              <Badge key={tag} variant="outline" className="text-xs">
                {tag}
              </Badge>
            ))}
          </div>
        </CardFooter>
      </Card>
    </Link>
  );
};

export default BusinessCard;
